export default __webpack_public_path__ + "static/media/fireflink-white.21c27999.svg";